export default __webpack_public_path__ + "static/media/4.761d1208.png";